import { HttpParams } from "@angular/common/http";
import { Errors } from "../generic";

export class PhysicalSearch {
    countBatch: string;
    locationClass: string;
    zone: string;
    countGenerationDate: string;
    countType: string;
    countStatus?: string;
    userId?: string
    itemCode?: string;
    batchView?: string;
    pageNumber: string;
    cusId?: string;
    buId?: string;
    fcyId?: string;
}
export class LabelAndDocRequest {
    fcyId?: string;
    buId?: string;
    custId?: string;
}

export class Paging {
    last?: boolean;
    first?: boolean;
    totalPages?: number;
    totalElements?: number;
    size?: number;
    number?: number;
    numberOfElements?: number;
    next?: string;
}
export class physicalInventorySummay {
    physicalInventory: PhysicalInventoryCount[];
    paging: Paging;
}
export class PhysicalInventoryCount {
    physicalId: string;
    countBatch: string;
    noOfLocation?: string;
    locationClass: string;
    channel: string;
    zoneDescription: string;
    location: string;
    countType?: string;
    countStatus?: string;
    createduser?: string;
    createdDate?: string;
    assignedUser: string;
    assignedDate?: string;
    completedUser?: string;
    completedDate?: string;
    itemCode?: string;
    countQty?: string;
    expectedQty?: string;

}

export class PhysicalInventoryResponse {

    success: boolean;
    physicalInvHeaderResponces: physicalInvHeaderResponces[];
    piMgmtBatchViewresponces: piphysicalInvHeaderResponces[];
    paging?: Paging; 
    message: any;
    /* requestIdentifier: string;
    transactionDate: string;
    errors?: Errors;*/ 
}

export class physicalInvHeaderResponces {
    //  physicalId:string;
    assignedUserName: string;
    channel: string;
    completedUser?: string;
    countBatch: string;
    countStatus?: string;
    countType?: string;
    createdBy?: string;
    createdDate?: string;
    expectedQty?: string;
    itemCode?: string;
    locationClass: string;
    locationType: string;
    destination:string;
    locationId: number;
    zoneDesc: string;
    piMgmtItemRes: piMgmtItemRes[];
    totalactualqty:string;
    totalExpectedqty:string;
    itemCodes:string;
    containerType:string;
    revContainerConfig: string;
    // noOfLocation?:string;
    // assignedDate?: string;    
    // completedDate?: string;   
    // countQty?: string; 
}
export class physicalDiscrepancyReqestObj{
    custId?: string;
    fcyId?: string;
    buId?: string;
    pageLimit?: string | '';
    page?: string | "0";
    countBatch?:string;
    locationClass?:string;
    zone?:string;
    sortOrderBy?:string;
    sortOrder?:string;
    varienceUnit?:string;
    varienceAmount?:string;
}
export class piMgmtItemRes {
    itemId: string;
    itemCode: string;
    expectedQty: string;
    countQty: string;
    varianceAmt: string;
    varianceQty: string;

}
export class piphysicalInvHeaderResponces {
    assignedUserName: string;
    completedUser?: string;
    countBatch: string;
    countStatus?: string;
    createdBy?: string;
    createdDate?: string;
    locationClass: string;
    noOfLocations?: string;
    zoneDesc: string;
    // assignedDate?: string;    
    // completedDate?: string;   
    // countQty?: string;   

}
export class inventoryDetail {
    assignedUserName: string;
    channel: string;
    completedUser?: string;
    countBatch: string;
    countStatus?: string;
    countType?: string;
    createdBy?: string;
    createdDate?: string;
    expectedQty?: string;
    itemCode?: string;
    locationClass: string;
    locationId: number;
    zoneDesc: string;
}

export class PhysicalInventoryFilterKeyValueforDomainList {
    requestIdentifier: string;
    transactionDate: string;
    success: boolean;
    countBatchList: [];
    zoneList: [];
    locationType: string[];
}
export class PhysicalInventoryDiscrepancyResponse {

    success: boolean;
    physicalInventoryDescripancyDetailsList: physicalInventoryDescripancyDetailsList[];
    paging?: Paging;
    totalVarianceDetails: totalVarianceDetails[];
    /* requestIdentifier: string;
     transactionDate: string;
     errors?: Errors;*/
}
export class totalVarianceDetails{
    expectedQty:number;
    actualQTY:number;
    piQtyVariance:number;
    piQtyVarianceAmount:number;
   piQtyVariancePercentage:number;
}
export class physicalInventoryDescripancyDetailsList {

}
 
export class PhysicalInventoryAcceptVarianceResponse {

    success: boolean;
    requestIdentifier: string;
    transactionDate: string;
    message: string;
}

export class PhysicalInventoryValidateCompletePIResponse {

    success: boolean;
    requestIdentifier: string;
    transactionDate: string;
    message: string;
    piMasterId:number;
    enableAcceptVariance: boolean;
    enableCompletePI: boolean;
}


export class PhysicalInventoryUpdateTaskReq {
    custId: number;
    buId: number;
    fcyId: number;
    taskDetails: taskDetails[];
}

export class taskDetails{
    batchNumber: string;
    countType: string;
    status: string;
    taskId: string;
}


export class PhysicalInventoryAcceptVarianceReq {

    cust_id: number;
    bu_id: number;
    fcy_id: number;
    pi_masterid: number;
    user_id: string;
    comments: string;
    action_type:string;
    locationType: string;
}

export class PhysicalInventoryValidateCompletePiReq {

    cust_id?: number;
    bu_id?: number;
    fcy_id?: number;
    
}
export class RequestParam {
    fcyId: string;
    custId: string;
    buId: string;

    getReqHttpParam(): HttpParams {
        let params = new HttpParams();
        params = params.append('fcyId', this.fcyId);
        params = params.append('custId', this.custId);
        params = params.append('buId', this.buId);
        return params;
    }
}
 
export class assignBatch {
    action: string;
    fcyId: string;
    custId: string;
    buId: string;
    batchNumber:string[];
    userId: any;
}

 
export class PhysicalInventoryItemResponse {
    success: boolean;
    itemRes: physicalInvItemHeaderResponces[];
    paging?: Paging; 
    message: any;
    requestIdentifier: string;
    transactionDate: string;
    errors?: Errors;
}
export class physicalInvItemHeaderResponces {    
    itemId?: string;
    itemCode?: string;
    countQty?: string;
    expectedQty?: string;
    varianceQty: string;
    varianceAmt: string;
    containerId:string;
    locTaskId: number;
    actualContId:string;
} 